module.exports = __webpack_public_path__ + "static/media/CF.56731cdb.svg";